import { render } from "./DashboardViewCoupons.vue?vue&type=template&id=7a25b620&scoped=true"
import script from "./DashboardViewCoupons.vue?vue&type=script&lang=js"
export * from "./DashboardViewCoupons.vue?vue&type=script&lang=js"

import "./DashboardViewCoupons.vue?vue&type=style&index=0&id=7a25b620&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a25b620"]])

export default __exports__